// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"bbcc4147","147":"af67ea62","459":"99afcfbc","578":"2d68aa2b","737":"4357e52f"}[chunkId] + ".chunk.js";
};